var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22329",
    "data-name": "Group 22329",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9880",
    "data-name": "Rectangle 9880",
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_4_",
    "data-name": "calendar (4)",
    transform: "translate(1.999 2.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23654",
    "data-name": "Path 23654",
    d: "M19.053,4.7h2.8V6.566a.936.936,0,1,0,1.864,0V1.4a.936.936,0,1,0-1.864,0V2.83h-2.8a.936.936,0,1,0,0,1.864Z",
    transform: "translate(-2.253 -0.377)",
    fill: "#d1131d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23655",
    "data-name": "Path 23655",
    d: "M11.609,4.728h2.8V6.592a.936.936,0,0,0,1.864,0V1.429a.936.936,0,0,0-1.864,0V2.855h-2.8a.936.936,0,0,0,0,1.864Z",
    transform: "translate(-1.345 -0.403)",
    fill: "#d1131d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23656",
    "data-name": "Path 23656",
    d: "M24.264,2.83h-.927a.936.936,0,1,0,0,1.864h.936a1.872,1.872,0,0,1,1.864,1.864v2.8H1.864V6.566A1.872,1.872,0,0,1,3.736,4.7h2.8V6.566a.936.936,0,1,0,1.864,0V1.4a.936.936,0,1,0-1.864,0V2.83h-2.8A3.736,3.736,0,0,0,0,6.566V24.3a3.736,3.736,0,0,0,3.736,3.745H24.264A3.736,3.736,0,0,0,28,24.3V6.566A3.736,3.736,0,0,0,24.264,2.83Zm0,23.336H3.736A1.873,1.873,0,0,1,1.872,24.3V11.238H26.136V24.3A1.872,1.872,0,0,1,24.264,26.166Z",
    transform: "translate(0 -0.377)",
    fill: "#d1131d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarRed);
export default __webpack_public_path__ + "static/media/calendar-red.98ff972a66507436172399884f841702.svg";
export { ForwardRef as ReactComponent };